export default (value, defaultValue) => {
  if (isNaN(parseFloat(value)) || !isFinite(value))
    return defaultValue;

  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
}
